export default __webpack_public_path__ + "static/media/screen7.2ee1be48.png";